
<template>
    <div>
        <div class="row">
            <div class="col-md-12 col-xs-12">
                <hr />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="flex-input">
  
                    <div style="text-align:center" class="imagePreviewWrapper"
                         @click="selectImage">
                        <img :src="previewImage" />
                    </div>
                    <input class="button" ref="fileInput"
                           type="file"
                           @input="pickFile">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-xs-12">
                <hr />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                previewImage: "/public/assets/img/DefaultFlag.png"
            };
        },
        methods: {
            selectImage() {
                this.$refs.fileInput.click()
            },
            pickFile() {
                let input = this.$refs.fileInput
                let file = input.files
                if (file && file[0]) {
                    let reader = new FileReader
                    reader.onload = e => {
                        this.previewImage = e.target.result
                        this.$emit('getInputImage', e.target.result)
                    }
                    reader.readAsDataURL(file[0])
               /*     this.$emit('getInputImage', file[0])*/
                }
            }
        }
    }
</script>

<style scoped>

 
    .flex-input {
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
    }
    .imagePreviewWrapper {
        width: 100%;
       
        display: block;
        cursor: pointer;
        margin: 0 auto 30px;
        background-size: cover;
        background-position: center center;
    }
</style>